;(function() {
  'use strict'

  angular.module('app.core').component('questionLicenseBadge', {
    templateUrl: 'question-license-badge.html',
    bindings: {
      license: '<',
    },
  })
})()
